import { surface } from "./foundation";
export const Card = surface("section", "card", "cyra-card");
export const CardHeader = surface(
  "header",
  "card-header",
  "flex items-start justify-between gap-3",
);
export const CardTitle = surface("div", "card-title", "font-medium");
export const CardDescription = surface("p", "card-description", "text-sm text-muted-foreground");
export const CardAction = surface("div", "card-action");
export const CardContent = surface("div", "card-content");
export const CardFooter = surface("footer", "card-footer", "flex gap-2");
